<template>
  <b-modal
    ref="bModalMappingWarehouse"
    size="lg"
    dialog-class="!max-w-[500px]"
    body-class="!p-[16px]"
    no-close-on-backdrop
    no-close-on-esc
    centered
    hide-footer
    hide-header
  >
    <h4 class="text-center text-[20px] font-semibold mt-[16px] mb-[24px] text-black">
      Mapping Gudang
    </h4>

    <warehouse-select-step-indicator
      ref="warehouseSelectStepIndicator"
    />

    <widget-list-warehouse
      v-show="isSelectWarehouseStep"
      key="step-warehouse"
      ref="widgetListWarehouse"
      :warehouse-fetcher="warehouseFetcher"
      :used-warehouses="usedWarehouses"
      @select="handleSelectedWarehouse"
    />
    <widget-list-store-address
      v-show="isSelectStoreAddressStep"
      key="step-store-address"
      ref="widgetListStoreAddress"
      :used-warehouses="usedWarehouses"
      :selected-warehouse="selectedWarehouse"
      @select="handleSelectedStoreAddress"
    />

    <div class="flex flex-row gap-[16px]">
      <b-button
        variant="outline-primary"
        class="w-full"
        @click="handleCancel"
      >
        {{ BTT_CANCEL }}
      </b-button>
      <b-button
        variant="primary"
        class="w-full !flex items-center justify-center gap-[8px]"
        :disabled="isMutating || PRIMARY_DISABLED"
        @click="handleNext"
      >
        <b-spinner
          v-if="isMutating"
          small
          variant="white"
        />
        {{ BTT_PRIMARY }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import WarehouseSelectStepIndicator from './WarehouseSelectStepIndicator.vue'
import WidgetListWarehouse from './WidgetListWarehouse.vue'
import WidgetListStoreAddress from './WidgetListStoreAddress.vue'
import { MAPPING_WAREHOUSE_STEP } from './config'

export default {
  name: 'ModalMappingWarehouse',
  components: {
    WarehouseSelectStepIndicator,
    WidgetListWarehouse,
    WidgetListStoreAddress,
  },
  props: {
    warehouseFetcher: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      MAPPING_WAREHOUSE_STEP,
      data: null,
      currentStep: MAPPING_WAREHOUSE_STEP.SELECT_WAREHOUSE,
      selectedWarehouse: null,
      selectedStoreAddress: null,
      searchWarehouse: '',
      isMutating: false,
    }
  },
  computed: {
    isSelectWarehouseStep() {
      return this.currentStep === MAPPING_WAREHOUSE_STEP.SELECT_WAREHOUSE
    },
    isSelectStoreAddressStep() {
      return this.currentStep === MAPPING_WAREHOUSE_STEP.SELECT_STORE_ADDRESS
    },
    BTT_CANCEL() {
      return this.isSelectWarehouseStep ? 'Batal' : 'Kembali'
    },
    PRIMARY_DISABLED() {
      return this.isSelectWarehouseStep ? !this.selectedWarehouse : !this.selectedStoreAddress
    },
    BTT_PRIMARY() {
      return this.isSelectWarehouseStep ? 'Selanjutnya' : 'Selesai'
    },
    usedWarehouses() {
      return this.data?.warehouses || []
    },
  },
  methods: {
    /**
     * Show the modal mapping warehouse and set the initial state
     * @param {Object} data - marketplace data
     */
    show(data) {
      this.data = data
      this.currentStep = MAPPING_WAREHOUSE_STEP.SELECT_WAREHOUSE
      this.selectedWarehouse = null
      this.selectedStoreAddress = null
      this.$nextTick(() => {
        if (this.$refs.bModalMappingWarehouse) {
          this.$refs.bModalMappingWarehouse.show()
        }
      })
    },
    /**
     * Hide the modal mapping warehouse and reset the state
     */
    hide() {
      this.isMutating = false
      this.currentStep = MAPPING_WAREHOUSE_STEP.SELECT_WAREHOUSE
      this.selectedWarehouse = null
      this.selectedStoreAddress = null
      this.$refs.bModalMappingWarehouse.hide()
    },
    /**
     * Handle the selected warehouse event from the child component.
     * @param {Object} warehouse - warehouse data
     */
    handleSelectedWarehouse(warehouse) {
      this.selectedWarehouse = warehouse
    },
    /**
     * Handle the selected store address event from the child component.
     * @param {Object} address - store address data
     */
    handleSelectedStoreAddress(address) {
      this.selectedStoreAddress = address
    },
    /**
     * Cancel the mapping process
     */
    handleCancel() {
      if (this.isSelectWarehouseStep) {
        this.hide()
      } else {
        this.$refs.warehouseSelectStepIndicator.prevStep()
        this.currentStep = MAPPING_WAREHOUSE_STEP.SELECT_WAREHOUSE
      }
    },
    /**
     * Routing user so they can mapping the warehouse with the store address
     */
    async handleNext() {
      this.isMutating = true

      // step 1 when user select warehouse
      if (this.isSelectWarehouseStep) {
        this.currentStep = MAPPING_WAREHOUSE_STEP.SELECT_STORE_ADDRESS
        this.isMutating = false
        if (this.$refs.warehouseSelectStepIndicator?.nextStep) {
          this.$refs.widgetListStoreAddress.setShopInfo(this.data.shop_id, this.data.shop_name)
          this.$refs.warehouseSelectStepIndicator.nextStep()
        }
        return
      }

      // step 2 when user select store address
      this.$emit('complete', {
        marketplace: this.data.marketplace,
        warehouseId: this.selectedWarehouse.warehouse_id,
        addressId: this.selectedStoreAddress.address_id,
        shopId: this.data.shop_id,
      })
    },
  },
}
</script>
